/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EnEventStatus {
    SCHEDULED = 'SCHEDULED',
    RESCHEDULED = 'RESCHEDULED',
    INPROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    DELAYED = 'DELAYED',
    MISSED = 'MISSED',
    NOTCOMPLETED = 'NOT_COMPLETED',
    SKIPPED = 'SKIPPED',
    DELETED = 'DELETED'
}

